import config from '@/config/config';
import {
  Configuration as AuthorizationConfiguration,
  AccountApiFactory as AuthorizationAccountApiFactory,
  ApplicationsApiFactory as AuthorizationApplicationsApiFactory,
  PermissionsApiFactory as AuthorizationPermissionsApiFactory,
  QueryApiFactory as AuthorizationQueryApiFactory,
  RoleAssignmentsApiFactory as AuthorizationRoleAssignmentsApiFactory,
  RolesApiFactory as AuthorizationRolesApiFactory,
  UsersApiFactory as AuthorizationUsersApiFactory
} from '@etp/etp-authorization-client/axios';
import {
  Configuration as NodeModelConfiguration,
  NodeModelApiFactory
} from '@etp/etp-nodemodelgit-client/axios';
import {
  Configuration as ReportingConfiguration,
  ReportConfigurationApiFactory
} from '@etp/etp-reporting-client/axios';
import {
  Configuration as InfraConfiguration,
  CostsApiFactory as InfraCostsApiFactory,
  DeploymentApiFactory as InfraDeploymentApiFactory,
  DeploymentTaskApiFactory as InfraDeploymentTaskApiFactory,
  ResourceApiFactory as InfraResourceApiFactory,
  TenantApiFactory as InfraTenantApiFactory
} from '@etp/etp-infra-client';
import {
  Configuration as ProfileConfiguration,
  ProfileApiFactory
} from '@etp/etp-profile-client/axios';
import {
  Configuration as PipelinesConfiguration,
  PipelinesApiFactory
} from '@etp/etp-pipelines-client/axios';
import {
  Configuration as StorageConfiguration,
  ConfigurationApiFactory as StorageConfigurationApiFactory,
  FileUploadApiFactory as StorageFileUploadApiFactory,
  ObjectsApiFactory as StorageObjectsApiFactory
} from '@etp/etp-storage-client/axios';
import {
  Configuration as EngagementsConfiguration,
  EngagementApiFactory
} from '@etp/etp-engagements-client/axios';
import {
  Configuration as DashboardingConfiguration,
  DashboardingApiFactory
} from '@etp/etp-dashboarding-client/axios';
import {
  Configuration as RbacConfiguration,
  RBACApiFactory
} from '@etp/etp-rbac-client';
import {
  Configuration as CostSavingCofiguration,
  AutoPauseExclusionsApiFactory
} from '@etp/etp-costsaving-client/axios';
import {
  Configuration as ConnectorsConfiguration,
  ConfigurationApiFactory,
  ConnectorsApiFactory
} from '@etp/etp-connectors-client';
import {
  Configuration as GainBffConfiguration,
  BFFApiFactory as GainBffApiFactory
} from '@etp/etp-gain-bff-client/axios';
import {
  Configuration as BFFConfiguration,
  BFFApiFactory as APIBFFApiFactory
} from '@etp/etp-bff-client/axios';
import axiosInstance from './web-api/axiosInstance';

export function createAuthorisationAccountClient() {
  const authorisationApi = 'authorisationEndpoint';
  return AuthorizationAccountApiFactory(
    new AuthorizationConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[authorisationApi]['uri']
  );
}
export function createAuthorisationApplicationsClient() {
  const authorisationApi = 'authorisationEndpoint';
  return AuthorizationApplicationsApiFactory(
    new AuthorizationConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[authorisationApi]['uri'],
    axiosInstance
  );
}
export function createAuthorisationPermissionsClient() {
  const authorisationApi = 'authorisationEndpoint';
  return AuthorizationPermissionsApiFactory(
    new AuthorizationConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[authorisationApi]['uri'],
    axiosInstance
  );
}
export function createAuthorisationQueryClient() {
  const authorisationApi = 'authorisationEndpoint';
  return AuthorizationQueryApiFactory(
    new AuthorizationConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[authorisationApi]['uri'],
    axiosInstance
  );
}
export function createAuthorisationRoleAssignmentsClient() {
  const authorisationApi = 'authorisationEndpoint';
  return AuthorizationRoleAssignmentsApiFactory(
    new AuthorizationConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[authorisationApi]['uri'],
    axiosInstance
  );
}
export function createAuthorisationRolesClient() {
  const authorisationApi = 'authorisationEndpoint';
  return AuthorizationRolesApiFactory(
    new AuthorizationConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[authorisationApi]['uri'],
    axiosInstance
  );
}
export function createAuthorisationUsersClient() {
  const authorisationApi = 'authorisationEndpoint';
  return AuthorizationUsersApiFactory(
    new AuthorizationConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[authorisationApi]['uri'],
    axiosInstance
  );
}
export function createNodeModelClient() {
  const nodeModelApi = 'nodeModelEndpoint';
  return NodeModelApiFactory(
    new NodeModelConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[nodeModelApi]['uri'],
    axiosInstance
  );
}

export function createReportingConfigurationApiClient() {
  const reportingConfigurationApi = 'reportingEndpoint';
  return ReportConfigurationApiFactory(
    new ReportingConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[reportingConfigurationApi]['uri'],
    axiosInstance
  );
}

export function createInfraCostsClient() {
  const infraApi = 'infraEndpoint';
  return InfraCostsApiFactory(
    new InfraConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[infraApi]['uri'],
    axiosInstance
  );
}

export function createInfraDeploymentClient() {
  const infraApi = 'infraEndpoint';
  return InfraDeploymentApiFactory(
    new InfraConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[infraApi]['uri'],
    axiosInstance
  );
}

export function createInfraDeploymentTaskClient() {
  const infraApi = 'infraEndpoint';
  return InfraDeploymentTaskApiFactory(
    new InfraConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[infraApi]['uri'],
    axiosInstance
  );
}

export function createInfraResourceClient() {
  const infraApi = 'infraEndpoint';
  return InfraResourceApiFactory(
    new InfraConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[infraApi]['uri'],
    axiosInstance
  );
}

export function createInfraTenantClient() {
  const infraApi = 'infraEndpoint';
  return InfraTenantApiFactory(
    new InfraConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[infraApi]['uri'],
    axiosInstance
  );
}

export function createProfileApiClient() {
  const profileApi = 'profileEndpoint';
  return ProfileApiFactory(
    new ProfileConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[profileApi]['uri'],
    axiosInstance
  );
}

export function createPipelinesApiClient() {
  const pipelinesApi = 'pipelinesEndpoint';
  return PipelinesApiFactory(
    new PipelinesConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[pipelinesApi]['uri'],
    axiosInstance
  );
}

export function createStorageConfigurationApiClient() {
  const storageApi = 'storageEndpoint';
  return StorageConfigurationApiFactory(
    new StorageConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[storageApi]['uri'],
    axiosInstance
  );
}

export function createStorageFileUploadApiClient() {
  const storageApi = 'storageEndpoint';
  return StorageFileUploadApiFactory(
    new StorageConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[storageApi]['uri'],
    axiosInstance
  );
}

export function createStorageObjectsApiClient() {
  const storageApi = 'storageEndpoint';
  return StorageObjectsApiFactory(
    new StorageConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[storageApi]['uri'],
    axiosInstance
  );
}

export function createEngagementsApiClient() {
  const engagementsApi = 'engagementsEndpoint';
  return EngagementApiFactory(
    new EngagementsConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[engagementsApi]['uri'],
    axiosInstance
  );
}

export function createDashboardingApiClient() {
  const dashboardingApi = 'dashboardingEndpoint';
  return DashboardingApiFactory(
    new DashboardingConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[dashboardingApi]['uri'],
    axiosInstance
  );
}

export function createRbacApiClient() {
  const rbacApi = 'rbacEndpoint';
  return RBACApiFactory(
    new RbacConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[rbacApi]['uri'],
    axiosInstance
  );
}

export function createCostManagementClient() {
  const costManagementApi = 'costManagementEndpoint';
  return AutoPauseExclusionsApiFactory(
    new CostSavingCofiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[costManagementApi]['uri'],
    axiosInstance
  );
}

export function createConnectorsClient() {
  const connectorsApi = 'connectorsEndpoint';
  return ConnectorsApiFactory(
    new ConnectorsConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[connectorsApi]['uri'],
    axiosInstance
  );
}

export function createConnectorsConfigurationClient() {
  const connectorsApi = 'connectorsEndpoint';
  return ConfigurationApiFactory(
    new ConnectorsConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[connectorsApi]['uri'],
    axiosInstance
  );
}

export function createGainBffClient() {
  const gainBffApi = 'gainBffEndpoint';
  return GainBffApiFactory(
    new GainBffConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[gainBffApi]['uri'],
    axiosInstance
  );
}

export function createApiBffClient() {
  const bffApi = 'bffEndpoint';
  return APIBFFApiFactory(
    new BFFConfiguration({
      baseOptions: {
        headers: {}
      }
    }),
    config.api[bffApi]['uri'],
    axiosInstance
  );
}
